import { render, staticRenderFns } from "./FormGetProductFamiliesGroup.vue?vue&type=template&id=182e6e92&scoped=true&"
import script from "./FormGetProductFamiliesGroup.vue?vue&type=script&lang=js&"
export * from "./FormGetProductFamiliesGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormGetProductFamiliesGroup.vue?vue&type=style&index=0&id=182e6e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e6e92",
  null
  
)

export default component.exports